import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 28px;
  }
`;

export const CreateButton = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #ffc300;
    transform: scale(1.05);
  }
`;

export const SearchArea = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  label {
    font-size: 12px;
    color: #bbb;
    text-transform: uppercase;
  }

  input {
    height: 40px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 15px;
    color: #fff;
    border-radius: 6px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }
`;

export const SearchButton = styled.button`
  height: 42px;
  align-self: flex-end;
  background: transparent;
  border: 1px solid #e6aa3a;
  color: #e6aa3a;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    background: #e6aa3a;
    color: #111;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 15px;
    text-align: left;
    white-space: nowrap;
  }

  thead tr {
    background-color: rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #e6aa3a;
  }
`;

export const TableHeaderCell = styled.th`
  color: #fff;
  font-weight: 600;
`;

export const TableRow = styled.tr`
  color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
  cursor: pointer;

  &:hover {
    background-color: rgba(230, 170, 58, 0.1);
  }
`;

export const TypeBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${(props) =>
    props.isWithdraw ? "rgba(231, 76, 60, 0.2)" : "rgba(46, 204, 113, 0.2)"};
  color: ${(props) => (props.isWithdraw ? "#e74c3c" : "#2ecc71")};
  border: 1px solid ${(props) => (props.isWithdraw ? "#e74c3c" : "#2ecc71")};
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 15px;
  color: #fff;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #e6aa3a;
    color: #111;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
